import { Injectable, NgZone } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { AuthService } from './auth.service';
import { UserDetailsDataForm } from '../_models/user-details-data-form';
import { catchError, map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable()
export class UserDataService {

  public static readonly URL_USER_CONTROLLER = environment.apiUrl + '/users';
  // register
  public static readonly URL_USER_REGISTER = UserDataService.URL_USER_CONTROLLER + "/register/";

  // NDA Accept
  public static readonly URL_NDA_ACCEPT_FORM = UserDataService.URL_USER_CONTROLLER + "/nda/";
  // User List
  public static readonly URL_ALL_USER = UserDataService.URL_USER_CONTROLLER + "/getAllUsers/";

  // Users count For Bar CART
  public static readonly URL_USER_COUNTS_FOR_CHART = UserDataService.URL_USER_CONTROLLER + "/getAllUserModuleStatusCount/";

  // Vderify reCaptcha Token
  public static readonly URL_VERIFY_RECAPTCHTOKEN = UserDataService.URL_USER_CONTROLLER + "/verifyRecaptcha/";
  
  // Get User Details by User id 
  public static readonly URL_GET_USER_DETAILS_BY_USER_ID = UserDataService.URL_USER_CONTROLLER + "/getUserDetailsByUserId/";

  // Update User Details 
  public static readonly URL_UPDATE_USER_DETAILS = UserDataService.URL_USER_CONTROLLER + "/updateUserDetails/";

  constructor(private http: HttpClient, private zone: NgZone,
    private route: ActivatedRoute, private router: Router, private authService: AuthService) { }


  saveUserDetails(userDetailsDataForm: UserDetailsDataForm): Observable<HttpResponse<UserDetailsDataForm>> {
    console.log('Sending user details form:', userDetailsDataForm);
    return this.http.post<UserDetailsDataForm>(UserDataService.URL_USER_REGISTER, userDetailsDataForm, { observe: 'response' })
      .pipe(map(response => {
        console.log('Response received:', response);
        // if (response.status === 200) {
        //   console.log(response);
        //   // this.reloadPage();
        // } 
        return response;
      }));
    // .pipe(catchError(this.handleError("Login Failed")));
  }


  acceptNdaForm(userDetailsDataForm: UserDetailsDataForm) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(UserDataService.URL_NDA_ACCEPT_FORM + userToken, userDetailsDataForm)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  getUserList() {
    let userToken: string = this.authService.getUserToken();
    return this.http.get(UserDataService.URL_ALL_USER + "/" + userToken)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  getUserCount() {
    let userToken: string = this.authService.getUserToken();
    return this.http.get(UserDataService.URL_USER_COUNTS_FOR_CHART + "/" + userToken)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  verifyRecaptchToken(gRecaptchatoken) {
    return this.http.get(UserDataService.URL_VERIFY_RECAPTCHTOKEN + "/" + gRecaptchatoken)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  getUserDetailsByuserId(userId) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(UserDataService.URL_GET_USER_DETAILS_BY_USER_ID + userId + '/' + userToken, userId)
      .pipe(catchError(this.handleError('Request Failed')));
  }

  updateUserDetailsByuserId(userDetailsDataForm: UserDetailsDataForm) {
    let userToken: string = this.authService.getUserToken();
    return this.http.post(UserDataService.URL_UPDATE_USER_DETAILS + '/' + userToken, userDetailsDataForm)
      .pipe(catchError(this.handleError('Request Failed')));
  }


  private handleError<T>(operation = 'operation', result?: T) {
    return (error: HttpErrorResponse) => {
      if (error.status === 401) {
        localStorage.removeItem('currentUser');
        window.location.replace('');
      }
      return Observable.throw(error);
    };
  }

}